<template>
  <div class="target-definition">
    <div
      class="target-definition__statement-container"
      :class="{ 'target-definition__drag-and-drop-mode': isDragAndDropActive }"
    >
      <scroll-panel :is-pinned="true">
        <div
          v-if="isDragAndDropActive"
          class="target-definition__drag-and-drop-message"
        >
          <p>Drag and Drop is Active</p>
        </div>
        <target-definition-statement
          class="target-definition__statement"
          :disabled="viewOnly"
          :definition="definition"
          :selected="selected"
          :enableNot="enableNot"
          :enableMinus="enableMinus"
          :enable-drag-and-drop="isDragAndDropActive"
          :is-dragging-part="isDraggingPart"
        ></target-definition-statement>
      </scroll-panel>
    </div>
    <div class="target-definition__controls">
      <definition-controls v-if="isTargetEditable"></definition-controls>
    </div>
  </div>
</template>

<script>
  import DefinitionControls from './DefinitionControls.vue'
  import ScrollPanel from '@/components/common/scrollPanel'
  import TargetDefinitionStatement from './targetDefinitionStatement'
  import {
    GROUP,
    UNGROUP,
    REMOVE_ATTRIBUTE,
    CLEAR_SELECTION,
  } from '@/appComponents/workbench/targetDefinition/store/actions'
  import { RESET_FAMILY_DATASETS } from '@/appLogic/workbench/common/store/actions'
  import { ACTIVATION_STATUS, DESTINATIONS } from '@/appLogic/targets/Constants'

  export default {
    components: {
      DefinitionControls,
      ScrollPanel,
      TargetDefinitionStatement,
    },
    props: {
      enableNot: {
        type: Boolean,
        default: true,
      },
      enableMinus: {
        type: Boolean,
        default: true,
      },
      viewOnly: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      definition() {
        return this.$store.getters['workbench/getDefinition']
      },
      selected() {
        return this.$store.getters['workbench/selected']
      },
      isTargetEditable() {
        return this.$store.getters['workbench/isTargetEditable'] && !this.viewOnly
      },
      isDragAndDropActive() {
        return this.$store.getters['workbench/isDragAndDropActive']
      },
      isDraggingPart() {
        return this.$store.getters['workbench/isDraggingPart']
      },
    },
    methods: {
      handleKeyboardShortcut(e) {
        switch (e.keyCode) {
          case 8: // Backspace Key
          case 46: // Delete Key
            let hasSelected = this.$store.getters['workbench/selectedCount'] > 0
            this.$store.dispatch('workbench/' + REMOVE_ATTRIBUTE)
            if (hasSelected) {
              this.$store.dispatch('workbench/' + RESET_FAMILY_DATASETS)
            }
            break

          case 71: // g Key
            this.$store.dispatch('workbench/' + GROUP)
            break

          case 85: // u Key
            this.$store.dispatch('workbench/' + UNGROUP)
            break

          case 27: // Esc Key
            this.$store.dispatch('workbench/' + CLEAR_SELECTION)
        }
      },
    },
    mounted() {
      this.boundHandleKeyboardShortcut = this.handleKeyboardShortcut.bind(this)
      window.addEventListener('keyup', this.boundHandleKeyboardShortcut)
    },
    destroyed() {
      window.removeEventListener('keyup', this.boundHandleKeyboardShortcut)
    },
  }
</script>

<style lang="scss">
  .target-definition {
    position: relative;
    display: flex;
    flex-grow: 1;
    margin: 0 rem(10);
    background: color(blue-black, dark);

    &__statement-container {
      position: relative;
      width: 100%;
    }

    &-statement {
      padding: rem(15) rem(20) rem(15) rem(20);
    }

    &__drag-and-drop-message {
      text-align: center;
      color: color(grays, medium);

      p {
        padding: 0;
        margin-top: rem(10);
        margin-bottom: -10px;
      }
    }

    &__drag-and-drop-mode {
      // drag and drop styles
      .cursor-left {
        &::before {
          content: '';
          display: block;
          width: 2px;
          height: 22px;
          background: yellow;
          position: absolute;
          left: -4px;
          @if ($target-definition-drag-and-drop-mode) {
            z-index: $target-definition-drag-and-drop-mode;
          } @else {
            z-index: 100;
          }
        }
      }
      .cant-drop-here {
        opacity: 0.3;
        cursor: not-allowed;
      }
      [draggable='true'] {
        cursor: move !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// TargetDefinition.vue?0480f8cd